/** @jsx jsx */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import React from 'react';
import { gs } from '../../common/utils';
const styles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  height: gs(2.5),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  width: gs(2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: "var(--ds-space-negative-025, -2px)"
});
export const Emoji = ({
  emoji
}) => {
  return jsx("span", {
    css: styles
  }, emoji);
};